export const GLN_LENGTH = 13
